import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=a3880f4a&scoped=true&"
import script from "./AddressForm.vue?vue&type=script&lang=js&"
export * from "./AddressForm.vue?vue&type=script&lang=js&"
import style0 from "./AddressForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddressForm.vue?vue&type=style&index=1&id=a3880f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3880f4a",
  null
  
)

export default component.exports